//引入需要展示的页面
import IndexPage from '@/page/IndexPage'
import LoginPage from '@/page/LoginPage'
import ShopListPage from '@/page/ShopListPage'
import ShopDetailPage from '@/page/ShopDetailPage'
import TaxRefundPage from '@/page/taxRefund/TaxRefundPage'
import TaxRefundListPage from '@/page/taxRefund/TaxRefundListPage'
import TaxRefundDetailPage from '@/page/taxRefund/TaxRefundDetailPage'
import MyPage from '@/page/mine/MyPage'
import TabListPage from '@/page/order/TabListPage'
import FundDetailPage from '@/page/order/FundDetailPage'
import RechargeRecordPage from '@/page/order/RechargeRecordPage'
import SettingsPage from '@/page/settings/SettingsPage'
import UserInfoPage from '@/page/settings/UserInfoPage'
import AddressInfoPage from '@/page/settings/AddressInfoPage'
import AlipayInfoPage from '@/page/settings/AlipayInfoPage'
import BankInfoPage from '@/page/settings/BankInfoPage'
import WechatInfoPage from '@/page/settings/WechatInfoPage'
import ModifyPasswordPage from '@/page/settings/ModifyPasswordPage'
import ApplyWithdrawPage from '@/page/mine/ApplyWithdrawPage'
import WithdrawRecordPage from '@/page/mine/WithdrawRecordPage'

const routes = [
    {
        path: '/',
        component: IndexPage
    },
    {
        path: '/login',
        component: LoginPage,
        meta: {
            hideFooter: true,
            title: '会员登录'
        }
    },
    {
        path: '/register',
        component: () => import('@/page/RegisterPage'),
        meta: {
            hideFooter: true
        }
    },
    {
        path: '/shopList',
        component: ShopListPage,
        meta: {
            title: '发现好货'
        }
    },
    {
        path: '/shopList/:id',
        component: ShopDetailPage
    },
    {
        path: '/taxRefund',
        component: TaxRefundPage,
        meta: {
            title: '促销分区'
        }
    },
    {
        path: '/taxRefund/list',
        component: TaxRefundListPage,
        meta: {
            title: '团购好货'
        }
    },
    {
        path: '/taxRefund/detail/:id',
        component: TaxRefundDetailPage
    },
    {
        path: '/customerService', component: () => import('@/page/CustomerServicePage'),
        meta: {
            hideFooter: true,
            title: '联系客服'
        }
    },
    //登录后的页面
    {
        path: '/my',
        component: MyPage,
        meta: {
            title: "个人中心"
        }
    },
    {
        path: '/tabList/:status',
        component: TabListPage,
        meta: {
            title: '我的订单'
        }
    },
    {
        path: '/fundDetail',
        component: FundDetailPage,
        meta: {
            title: '消费记录'
        }
    },
    {
        path: '/rechargeRecord',
        component: RechargeRecordPage,
        meta: {
            title: '充值记录'
        }
    },
    {
        path: '/settings',
        component: SettingsPage,
        meta: {
            title: '个人设置'
        }
    },
    {
        path: '/settings/userInfo', component: UserInfoPage,
        meta: {
            title: '个人资料'
        }
    },
    {
        path: '/settings/addressInfo', component: AddressInfoPage,
        meta: {
            title: '绑定收货地址'
        }
    },
    {
        path: '/settings/alipayInfo', component: AlipayInfoPage,
        meta: {
            title: '绑定支付宝'
        }
    },
    {
        path: '/settings/bankInfo', component: BankInfoPage,
        meta: {
            title: '绑定银行卡'
        }
    },
    {
        path: '/settings/wechatInfo', component: WechatInfoPage,
        meta: {
            title: '绑定微信'
        }
    },
    {
        path: '/settings/modifyPassword', component: ModifyPasswordPage,
        meta: {
            title: '修改密码'
        }
    },
    {
        path: '/applyWithdraw', component: ApplyWithdrawPage,
        meta: {
            title: '申请提现'
        }
    },
    {
        path: '/withdrawRecord', component: WithdrawRecordPage,
        meta: {
            title: '提现记录'
        }
    },
    {
        path: '/confirmGroupPurchase', component: () => import('@/page/taxRefund/ConfirmGroupPurchasePage'),
        meta: {
            hideFooter: true,
            title: '确认订单'
        }
    },
    { path: '/paySuccessPage', component: () => import('@/page/taxRefund/PaySuccessPage'), meta: { title: '交易成功' } },
    { path: '/seckillList', component: () => import('@/page/seckill/SeckillListPage'), meta: { title: '秒杀活动' } },
    { path: '/seckillDetail/:id', component: () => import('@/page/seckill/SeckillDetailPage'), meta: { title: '秒杀详情' } },
    {
        path:'/mine/recharge',component:()=>import('@/page/mine/RechargePage'),
    },
    { path: '/mine/message', component: () => import('@/page/mine/MessagePage'), meta: { title: '我的消息' } },
]

export default routes
